module.exports = __webpack_public_path__ + "img/check_small.61f75ab1.svg";